import React from "react";
import { statusColor } from "../lib/status";

const RoutesTable = ({ routes = [], onSelect }) => {
  return (
    <div className="panel entrance" data-testid="routes-panel">
      <div className="panel-head">
        <div className="panel-title">
          <div className="p-ic"><i className="fa-solid fa-diagram-project" /></div>
          Corridor Forecast
        </div>
        <span className="pill neutral">Tap a corridor for detail</span>
      </div>

      <div className="route-head">
        <div>Corridor</div>
        <div>Congestion</div>
        <div>Delay</div>
        <div>ETA</div>
        <div style={{ textAlign: "right" }}>Status</div>
      </div>

      <div className="routes-table" data-testid="routes-table">
        {routes.map((r) => (
          <div
            key={r.id}
            className="route-row"
            data-testid={`route-row-${r.id}`}
            onClick={() => onSelect(r.id)}
          >
            <div>
              <div className="rr-name">{r.name}</div>
              <div className="rr-sub">{r.from_place} → {r.to_place}</div>
            </div>
            <div>
              <div className="bar">
                <span
                  style={{ width: `${Math.round(r.congestion_index * 100)}%`, background: statusColor(r.status) }}
                />
              </div>
              <div className="rr-sub" style={{ marginTop: 5 }}>{Math.round(r.congestion_index * 100)}%</div>
            </div>
            <div className="rr-metric">+{r.delay_minutes}<small>min</small></div>
            <div className="rr-metric">{r.eta_minutes}<small>min</small></div>
            <div style={{ textAlign: "right" }}>
              <span className={`pill ${r.risk_level}`}>{r.status}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoutesTable;
